import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { put, get } from "../../../../utils/api";
import styles from "../../../../styles/gri/general.module.css";
import AddmultipleTables from "./AddmultipleTables";
import GRISidebar from "../../../../Layout/GRISidebar";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import AddDynamicMultipleTables from "./AddDynamicMultipleTable";

const GRI301_1 = ({hide}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
   const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
 const [addTables, setaddTables] = useState([
    {
      productName: "",
      measurementUnit: {
        mass: { active: true, remark: "" },
        volume: { active: false, remark: "" },
      },
      renewable: {
        rawMaterial: "",
        processMaterials: "",
        semiManufactured: "",
        packagingMaterials: "",
      },
      nonrenewable: {
        rawMaterial: "",
        processMaterials: "",
        semiManufactured: "",
        packagingMaterials: "",
      },
    },
  ]);

  const inputData = [
    {
      defalut: "Material Used",
      fields: [
        { title: "Raw Materials Used", fieldName: "rawMaterial" },
        {
          title: "Process Materials",
          // list: ["products"],
          fieldName: "processMaterials",
        },
        { title: "Semi Manufactured", fieldName: "semiManufactured" },
        { title: "Packaging Materials", fieldName: "packagingMaterials" },
      ],
    },
  ];

  const defaultSegments = [
    {
      romanindex: "i",
      title: "Non-Renewable Materials Used",
      field: "nonrenewable",
    },
    {
      romanindex: "ii",
      title: "Renewable Materials Used",
      field: "renewable",
    },
  ];

  const DropDownData = {
    heading: "Measurement Unit:",
    fieldName: "measurementUnit",
    fields: [
      {
        title: "Mass",
        fields: "mass",
        subfileds: "active",
        list: ["Kg", "Tons"],
        listFields: "remark",
      },
      {
        title: "Volume",
        fieldName: "measurementUnit",
        fields: "volume",
        subfileds: "active",
        listFields: "remark",
        list: ["Litre", "Kilo Litre", "M3"],
      },
    ],
  };

  const handleAdd = () => {
    setaddTables((prev) => [
      ...prev,
      {
        productName: "",
        // measurementUnit: {
        //   mass: {
        //     active:
        //       prev?.[prev.length - 1]?.measurementUnit?.mass?.active || false,
        //     remark:
        //       prev?.[prev.length - 1]?.measurementUnit?.mass?.remark || "",
        //   },
        //   volume: {
        //     active:
        //       prev?.[prev.length - 1]?.measurementUnit?.volume?.active || false,
        //     remark:
        //       prev?.[prev.length - 1]?.measurementUnit?.volume?.remark || "",
        //   },
        // },
         measurementUnit: {
          mass: {
            active:
               true,
            remark:
               "",
          },
          volume: {
            active:
              false,
            remark:
              "",
          },
        },
        renewable: {
          rawMaterial: "",
          processMaterials: "",
          semiManufactured: "",
          packagingMaterials: "",
        },
        nonrenewable: {
          rawMaterial: "",
          processMaterials: "",
          semiManufactured: "",
          packagingMaterials: "",
        },
      },
    ]);
  };

  const fetchData = async () => {
    await get(`/gri/get?type=GRI300&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
        console.log("datasqqq",res?.data?.data?.year )
        console.log("datas",disabled )

        const response = res.data.data.GRI300.materialUsedWeightOrVolumn;
        
        setaddTables(
          response.length > 0
            ? response.map((item) => ({
                productName: item?.productName,
                measurementUnit: {
                  mass: {
                    active: item?.measurementUnit?.mass?.active,
                    remark: item?.measurementUnit?.mass?.remark,
                  },
                  volume: {
                    active: item?.measurementUnit?.volume?.active,
                    remark: item?.measurementUnit?.volume?.remark,
                  },
                },
                renewable: {
                  rawMaterial: item?.renewable?.rawMaterial,
                  processMaterials: item?.renewable?.processMaterials,
                  semiManufactured: item?.renewable?.semiManufactured,
                  packagingMaterials: item?.renewable?.packagingMaterials,
                },
                nonrenewable: {
                  rawMaterial: item?.nonrenewable?.rawMaterial,
                  processMaterials: item?.nonrenewable?.processMaterials,
                  semiManufactured: item?.nonrenewable?.semiManufactured,
                  packagingMaterials: item?.nonrenewable?.packagingMaterials,
                },
              }))
            : [
                {
                  productName: "",
                  measurementUnit: {
                    mass: { active: true, remark: "" },
                    volume: { active: false, remark: "" },
                  },
                  renewable: {
                    rawMaterial: "",
                    processMaterials: "",
                    semiManufactured: "",
                    packagingMaterials: "",
                  },
                  nonrenewable: {
                    rawMaterial: "",
                    processMaterials: "",
                    semiManufactured: "",
                    packagingMaterials: "",
                  },
                },
              ]
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async () => {
    if(!disabled){
    try {
      await put(`/gri/update?Id=${id}`, {
        type: "GRI300",
        submitted301_1: true,
        materialUsedWeightOrVolumn: [...addTables],
      })
        .then((res) => {
          navigate(`/gri/gri300/301-2/${id}`);
        })
        .catch((err) => {
          console.log(err, "errors");
        });
    } catch (error) {
      console.log(error);
      // setsnackOpen({
      //   open: true,
      //   message: error.data.message,
      //   severity: "error",
      // });
    }
  }else {
    navigate(`/gri/gri300/301-2/${id}`);
  }
  };

  const renderContent = ({hide}) => (
    <>
      {!hide && <p className={styles.section_heading} style={{marginBottom : hide ? "-1rem" : "0"}}>
        301 :{" "}
        <span className={styles.main_heading_underline} >Material Used</span>
      </p>}
      <p className={styles.main_heading} style={{marginBottom : hide ? "-1rem" : "0", }}>
        301-1 :{" "}
        <span className={styles.main_heading_underline}>
          Materials used by weight or volume
        </span>
      </p>
      <AddDynamicMultipleTables
        title="a. Total weight or volume of materials that are used to produce and package the organization’s primary products and services during the reporting period, by:"
        {...{
          addTables,
          setaddTables,
          errors,
          setErrors,
          inputData,
          defaultSegments,
          DropDownData,
          handleAdd,
          disabled: disabled,
          hide: hide
        }}
      />
       
    </>
 )
  return (
  <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
        <Box sx={{  width: "98%", ml:2 }}>
          <ReviewBox url={"/gri"} handleSubmit={handleSubmit}  />
        </Box>
      ) : (
      <Box textAlign="right" sx={{ mt: 3 }}>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
        >
          Save & Continue <EastIcon sx={{ ml: 2 }} />
        </Button>
      </Box>
      )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};
export default GRI301_1;
